import QuestionAddedSoFar from "../../../components/add-questions/new-question/question-added-so-far";
import AmpleHireLoader from "../../../components/loaders/ample-hire-loader";

const QuestionsAddedSoFarSection = ({
  questionType = "",
  jobQuestions,
  isPublished,
  isLoadingJobQuestions,
  handleGetAllQuestions=()=>{},
}) => {
  if (isLoadingJobQuestions) {
    return <AmpleHireLoader />;
  }

  return jobQuestions ? (
    jobQuestions.map((question, index) => (
      <QuestionAddedSoFar
        key={question.id}
        queSerialNum={index + 1}
        question={question}
        handleGetAllQuestions={handleGetAllQuestions}
        questionType={questionType}
        isPublished={isPublished}
      />
    ))
  ) : (
    <>No Questions Added for this round.</>
  );
};

export default QuestionsAddedSoFarSection;
